export default "__VITE_ASSET__BNjakGSd__"